import { BreakRuleTable } from 'components/table/break_rule/BreakRuleTable';

export const BreakRules = () => {

    return (
        <><BreakRuleTable/></>
    )
}